import { Link, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogOut, ChevronRight } from "lucide-react";
import { modulosPiloto } from "@/lib/inicio";

export default function MisApps() {
  const { user, logout } = useAuth();
  const apps = modulosPiloto(user);
  if (user?.role !== "piloto") return <Navigate to="/panel" replace />;
  if (apps.length === 1) return <Navigate to={apps[0][1]} replace />;
  return (
    <div className="min-h-screen bg-white text-black" data-testid="mis-apps">
      <header className="bg-black text-white px-4 h-16 flex items-center justify-between">
        <div className="font-black text-xl">Hola, {user?.name || user?.email}</div>
        <button onClick={logout} className="p-2" aria-label="Salir" data-testid="mis-apps-logout"><LogOut className="w-6 h-6" /></button>
      </header>
      <main className="p-4 max-w-md mx-auto space-y-3">
        <div className="text-sm font-bold uppercase text-zinc-500">Sus módulos</div>
        {apps.length === 0 && <div className="text-zinc-600" data-testid="mis-apps-vacio">No tiene módulos autorizados. Consulte al administrador.</div>}
        {apps.map(([k, to, label]) => (
          <Link key={k} to={to} className="flex items-center justify-between h-20 px-5 rounded-xl border-2 border-zinc-900 text-2xl font-black active:bg-zinc-100" data-testid={`mis-apps-${k}`}>
            {label} <ChevronRight className="w-7 h-7" />
          </Link>
        ))}
      </main>
    </div>
  );
}
